export default {"src":"/_next/static/media/without_text.32f21929.svg","height":595,"width":842};